import { ICategory } from "../General.interfaces";

export const getSubCategoriesByParentName = (parentName: string, categories: ICategory[]) => {
    const parentId = categories?.find((item) => item.object_name === parentName)?.id;
    return categories?.filter((item) => item.parent_id === parentId);
};
